import { Location, NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";
import { ButtonComponent } from "../button/button.component";

@Component({
  selector: "app-page-header",
  templateUrl: "./page-header.component.html",
  styleUrls: ["./page-header.component.scss"],
  standalone: true,
  imports: [NgIf, ButtonComponent],
})
export class PageHeaderComponent {
  @Input() title: string | undefined;
  @Input() showGoBack: boolean = false;
  @Input() backButtonColor: string = "secondary";
  @Input() backButtonText: string = "Go Back";
  @Input() backButtonSize: "sm" | "lg" | null = null;

  constructor(private location: Location) {}

  onGoBackClicked(): void {
    this.location.back();
  }
}
